import AboutAyabonga from './AboutAyabonga';
import { Helmet } from 'react-helmet';
import NavigationBar from '../components/newnav';

const personJsonLd = {
  "@context": "https://schema.org",
  "@type": "Person",
  "name": "Ayabonga Qwabi",
  "jobTitle": "Senior Product Engineer",
  "url": "https://www.qwabi.co.za",
  "sameAs": [
    "https://business.qwabi.co.za",
    "https://twitter.com/ayabongaqwabi"
  ],
  "worksFor": {
    "@type": "Organization",
    "name": "Qwabi Engineering",
    "url": "https://business.qwabi.co.za"
  },
  "description": "Senior Product Engineer and Technical Co-founder as a Service (TaaS) specialising in mobile app development, web application development, AI agent development, and custom software systems for South African businesses.",
  "address": {
    "@type": "PostalAddress",
    "addressCountry": "ZA"
  }
};

export default function AboutDeveloperPage() {
  return (
    <main>
      <Helmet>
        <title>Built by Ayabonga Qwabi | ClinicPlus</title>
        <meta name="description" content="ClinicPlus was built by Ayabonga Qwabi, a Senior Product Engineer specialising in Occupational health bookings, Medical fitness examinations, Company..." />
        <link rel="canonical" href="https://clinicplusbooking.co.za/about-developer" />
        <meta property="og:title" content="Built by Ayabonga Qwabi | ClinicPlus" />
        <meta property="og:description" content="ClinicPlus was built by Ayabonga Qwabi, a Senior Product Engineer specialising in Occupational health bookings, Medical fitness examinations, Company..." />
        <meta property="og:url" content="https://clinicplusbooking.co.za/about-developer" />
        <meta property="og:type" content="profile" />
        <meta name="twitter:card" content="summary_large_image" />
        <script type="application/ld+json">{JSON.stringify(personJsonLd)}</script>
      </Helmet>
      <div className='d-flex flex-column min-vh-100 main-about'>
      <NavigationBar />
      <p style={{ margin: '0 0 24px', lineHeight: 1.7 }}>
        ClinicPlus was built by <a href="https://www.qwabi.co.za" rel="author">Ayabonga Qwabi</a> of <a href="https://business.qwabi.co.za">Qwabi Engineering</a>, with senior product engineering focused on production-ready systems for South African businesses.
      </p>
      <AboutAyabonga
        projectName="ClinicPlus"
        projectCategory="occupational health booking platform"
        highlightServices={["booking","web-app","admin","crm"]}
      />
      </div>
    </main>
  );
}
